import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/preloader.gif'


const _withScopeId = n => (_pushScopeId("data-v-99623a72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "preloader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_ctx.preloader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}